module.exports = __webpack_public_path__ + "img/mail-orange.9740919a.svg";